import React, { useState, useEffect } from "react";
import { axInst } from "../Service/Service";
import { useQuery } from "@tanstack/react-query";
const fetchAccountName = async (searchData) => {
  const basicAuth =
    "Basic " +
    btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}accountName`,
      { searchData },
      {
        headers: {
          Authorization: basicAuth,
        },
      }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Fetch ARN Number API
const fetchArnNumber = async (searchData) => {
  const basicAuth =
    "Basic " +
    btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}arnNumber`,
      { searchData },
      {
        headers: {
          Authorization: basicAuth,
        },
      }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Fetch Vehicle registration Number API
const fetchVehicleRegistrationNumber = async (searchData) => {
  const basicAuth =
    "Basic " +
    btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}vehicleRegistrationNumber`,
      { searchData },
      {
        headers: {
          Authorization: basicAuth,
        },
      }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Fetch Vehicle registration Number API
const fetchChassisNumber = async (searchData) => {
  const basicAuth =
    "Basic " +
    btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}assetNumber`,
      { searchData },
      {
        headers: {
          Authorization: basicAuth,
        },
      }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

function Search({
  isArn,
  setIsArn = () => { },
  handleSearchFromParent = (isArn) => { },
}) {
  const [selectedValue, setSelectedValue] = useState("");
  const [placeholder, setPlaceholder] = useState("Please select search type");
  const [isDisabled, setIsDisabled] = useState(true);
  const [value, setValue] = useState("");
  const [searchData, setSearchData] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [isArn, setIsArn] = useState(null);
  const [isArnData, setisArnData] = useState(null);

  // Query to fetch AccountName based on searchData
  const {
    data: AccountName,
    isLoading: isLoadingAccountName,
    error: accountNameError,
    refetch: refetchAccountName,
  } = useQuery({
    queryKey: ["accountName", searchData],
    queryFn: () => fetchAccountName(searchData),
    enabled: !!searchData && selectedValue === "Account Name",
  });

  // Query to fetch ArnNumber based on searchData
  const {
    data: ArnNumber,
    isLoading: isLoadingArnNumber,
    error: arnNumberError,
    refetch: refetchArnNumber,
  } = useQuery({
    queryKey: ["arnNumber", searchData],
    queryFn: () => fetchArnNumber(searchData),
    enabled: !!searchData && selectedValue === "ARN Number",
  });
  // Query to fetch VehicleRegistrationNumber based on searchData
  const {
    data: vehicleRegistrationNumber,
    isLoading: isLoadingvehicleRegistrationNumber,
    error: vehicleRegistrationNumberError,
    refetch: refetchVehicleRegistrationNumber,
  } = useQuery({
    queryKey: ["vehicleRegistrationNumber", searchData],
    queryFn: () => fetchVehicleRegistrationNumber(searchData),
    enabled: !!searchData && selectedValue === "Vehicle Registration Number",
  });
  // Query to fetch fetchChassisNumber based on searchData
  const {
    data: chassisNumber,
    isLoading: isLoadingchassisNumber,
    error: chassisNumberError,
    refetch: refetchChassisNumber,
  } = useQuery({
    queryKey: ["chassisNumber", searchData],
    queryFn: () => fetchChassisNumber(searchData),
    enabled: !!searchData && selectedValue === "Chassis Number",
  });

  const options = [
    {
      label: "Account Name",
      value: "Account Name",
      placeholder: "Enter account name",
    },
    {
      label: "ARN Number",
      value: "ARN Number",
      placeholder: "Enter ARN Number",
    },
    {
      label: "Vehicle Registration Number",
      value: "Vehicle Registration Number",
      placeholder: "Enter vehicle registration number",
    },
    {
      label: "Chassis Number",
      value: "Chassis Number",
      placeholder: "Enter chassis number",
    },
  ];

  const handleDropdownChange = (e) => {
    const selectedOption = options.find(
      (option) => option.value === e.target.value
    );
    setSelectedValue(selectedOption ? selectedOption.value : "");
    setPlaceholder(
      selectedOption ? selectedOption.placeholder : "Please select search type"
    );
    setIsDisabled(!selectedOption);
    setValue("");
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    setSearchData(inputValue);
    setIsDropdownOpen(true);
  };

  const handleSuggestionClick = (suggestion) => {
    if (selectedValue === "Account Name") {
      setValue(suggestion._source.ACCOUNT_NAME);
      setIsArn(suggestion._source.ARN);
    } else if (selectedValue === "ARN Number") {
      setValue(suggestion._source.ARN);
      setIsArn(suggestion._source.ARN);
    } else if (selectedValue === "Vehicle Registration Number") {
      setValue(suggestion._source.LICENSE_NO);
      setIsArn(suggestion._source.ARN);
    } else if (selectedValue === "Chassis Number") {
      setValue(suggestion._source.ASSET_NUM);
      setIsArn(suggestion._source.ARN);
    }
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (searchData) {
      if (selectedValue === "Account Name") {
        refetchAccountName();
      } else if (selectedValue === "ARN Number") {
        refetchArnNumber();
      } else if (selectedValue === "Vehicle Registration Number") {
        refetchVehicleRegistrationNumber();
      } else if (selectedValue === "Chassis Number") {
        refetchChassisNumber();
      }
    }
  }, [
    searchData,
    selectedValue,
    refetchAccountName,
    refetchArnNumber,
    refetchVehicleRegistrationNumber,
    refetchChassisNumber,
  ]);

  const handleSearchClick = (isArnData) => {
    if (isArnData) {
      handleSearchFromParent(isArnData);
      // isArnData({ type: selectedValue, query: value });
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-0">
        <div className="text-white text-center p-2 rounded-lg shadow-5xl">
          <select
            value={selectedValue}
            onChange={handleDropdownChange}
            id="searchType"
            className="block bg-white text-[#6b6769] w-full p-2 rounded-lg border border-slate-200 placeholder:text-[#6b6769]"
          >
            <option value="" disabled>
              Select search type
            </option>
            {options.map((options) => (
              <option key={options.label} value={options.value}>
                {options.label}
              </option>
            ))}
          </select>
        </div>
        <div className="text-white text-center p-2 rounded-lg shadow-5xl">
          <input
            type="text"
            id="value"
            placeholder={placeholder}
            className="block w-full p-2 rounded-lg bg-white text-black border border-slate-200 placeholder:text-[#6b6769]"
            autoComplete="off"
            onChange={handleChange}
            value={value}
            disabled={isDisabled}
          />
        </div>
        <div className="text-white text-center p-2 rounded-lg shadow-5xl">
          <div className="flex gap-5">
            <input
              type="text"
              id="arnNumber"
              className="block w-full p-2 rounded-lg bg-white text-black border border-slate-200 placeholder:text-[#6b6769]"
              placeholder="ARN Number"
              autoComplete="off"
              value={isArn}
              readOnly
            />
            {isDropdownOpen &&
              selectedValue === "Account Name" &&
              AccountName &&
              Array.isArray(AccountName) &&
              AccountName.length > 0 && (
                <ul className="absolute left-1/2 transform -translate-x-1/2 z-10 w-[30%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-[42px]">
                  {AccountName.map((suggestion, index) =>
                    suggestion && suggestion._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion._source.ACCOUNT_NAME
                          ? suggestion._source.ACCOUNT_NAME
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index} // You need a key here for each list item
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "ARN Number" &&
              ArnNumber &&
              Array.isArray(ArnNumber) &&
              ArnNumber.length > 0 && (
                <ul className="absolute left-1/2 transform -translate-x-1/2 z-10 w-[30%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-[42px]">
                  {ArnNumber.map((suggestion, index) =>
                    suggestion && suggestion._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion._source.ARN
                          ? suggestion._source.ARN
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index} // You need a key here for each list item
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "Vehicle Registration Number" &&
              vehicleRegistrationNumber &&
              Array.isArray(vehicleRegistrationNumber) &&
              vehicleRegistrationNumber.length > 0 && (
                <ul className="absolute left-1/2 transform -translate-x-1/2 z-10 w-[30%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-[42px]">
                  {vehicleRegistrationNumber.map((suggestion, index) =>
                    suggestion && suggestion._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion._source.LICENSE_NO
                          ? suggestion._source.LICENSE_NO
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index} // You need a key here for each list item
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}
            {isDropdownOpen &&
              selectedValue === "Chassis Number" &&
              chassisNumber &&
              Array.isArray(chassisNumber) &&
              chassisNumber.length > 0 && (
                <ul className="absolute left-1/2 transform -translate-x-1/2 z-10 w-[30%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-[42px]">
                  {chassisNumber.map((suggestion, index) =>
                    suggestion && suggestion._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion._source.ASSET_NUM
                          ? suggestion._source.ASSET_NUM
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index} // You need a key here for each list item
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            <button
              type="button"
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              value={isArn}
              onClick={() => handleSearchClick(isArn)}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Search;
